import { messages } from 'actions/messages';

async function changeLanguage(value: availableLocales) {
  messages.load(value);
}

export { changeLanguage };
